<template>
  <div id="app" ref="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"  :key="$route.fullPath" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"   :key="$route.fullPath"/>
  </div>
</template>

<script>
import store from "./store";
import { userDetail } from '@/api/user';
export default {
  name: "App",
  data() {
    return {
      flag: []
    };
  },
  watch: {
    $route: function (to, from) {
      if(document.getElementById('top')){
          document.getElementById('top').scrollIntoView(0);
      }
    },
  },
  created() {
    try{
      // 在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(localStorage.getItem("store"))
          )
        );
      }
      // 在页面刷新时将vuex里的信息保存到sessionStorage里
      // beforeunload事件在页面刷新时先触发
      window.addEventListener("beforeunload", () => {
          sessionStorage.setItem("store", JSON.stringify(this.$store.state));
      });
      if(this.$route.name == 'userInfo'||this.$route.name == 'orderInfo'||this.$route.name == 'qrPay'){
          this._getDetail();
      }
    }catch(err){
      console.log(err.message);
    }
  },
    mounted() {
      let height = this.$refs.app.offsetHeight;
      this.$store.state.windowHeight = height;
      window.addEventListener("resize", this.handleWindow, true);
    },
    methods:{
      handleWindow() {
        let height = this.$refs.app.offsetHeight;
        this.$store.state.windowHeight = height;
      },
      async _getDetail(){
        let res = await userDetail({});
        if(res.code == 200){
            this.$store.state.customer.customerInfo.customerName = res.data.userData.customerName;
            this.$store.state.customer.customerInfo.mobile = res.data.userData.phone;
        }
      }
    }
};
</script>

<style>
#app {
  margin: 0;
  padding: 0;
}
*{
  font-family: 宋体;
}
body {
  background: #eeeeee;
}
input:focus::-webkit-contacts-auto-fill-button{
  opacity: 0;
}
input::-webkit-credentials-auto-fill-button {
  display: none !important;
  visibility: hidden;
  pointer-events: none;
  position: absolute; /* 避免占用 input 元素额外的 padding，正常情况下存在 display: none!; 就可以了 */
  right: 0;
}
</style>
